import React from 'react'
import { Box } from '@chakra-ui/react'
import { PublicRoute } from '../components/Auth/ProtectedRoute'
import { RegisterForm } from '../components/Auth/RegisterForm'

export const RegisterPage: React.FC = () => {
  return (
    <PublicRoute>
      <Box
        minH="100vh"
        bg="gray.50"
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={4}
      >
        <RegisterForm />
      </Box>
    </PublicRoute>
  )
}

export default RegisterPage 